<template>
  <div class="wl-container">
    <div class="wl-content-container">

      <!-- 搜索框 -->
      <div class="wl-search-bar">
        <div class="wl-left">
          <el-input :placeholder="$t('KPMG_SYSTEM_ADMIN_MANAGEMENT_PLACE_HOLDER')"
                    v-model="searchContent"
                    @keyup.enter.native="searchAdmin"
                    maxlength="100"
                    clearable
                    @clear="searchAdmin"
                    class="input-with-select">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="searchAdmin" style="cursor: pointer" />
          </el-input>

        </div>

        <div class="wl-right">

          <select-ad ref="selectAdd"
                     class="wl-select-add"
                     :api="selectFromUser"
                     :filter="adFilter"
                     :onAdd="onAddAccount"></select-ad>

        </div>
      </div>

      <!-- 表格 -->
      <div class="table-container-wrapper">
        <el-table height="100%"
                  v-loading="loading"
                  :data="data"
                  border
                  stripe>

          <el-table-column type="index"
                           width="70"></el-table-column>

          <el-table-column prop="staffNo"
                           :label="$t('TABLE_HEADER_EMAIL_StaffNo')"
                           width="120"></el-table-column>

          <el-table-column prop="userName"
                           width="220"
                           :label="$t('TABLE_HEADER_EMAIL_StaffName')"></el-table-column>

          <el-table-column prop="profitCenter"
                           width="200"
                           :label="$t('TABLE_HEADER_EMAIL_ProfitCenter')"></el-table-column>

          <el-table-column prop="position"
                           width="300"
                           :label="$t('TABLE_HEADER_EMAIL_Position')"></el-table-column>

          <el-table-column prop="email"
                           :label="$t('TABLE_HEADER_EMAIL_Email')"></el-table-column>

          <el-table-column prop="action"
                           width="100"
                           align="center"
                           fixed="right"
                           :label="$t('TABLE_HEADER_Action')">
            <template slot-scope="scope">
              <i class="el-icon-delete wl-icon-delete"
                 @click="onDeleteAccount(scope.row)"></i>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination class="wl-pagination"
                     :current-page="pagination.pageNum"
                     :page-size="pagination.pageSize"
                     @current-change="onCurrentPageChange"
                     @size-change="onSizeChange"
                     :page-sizes="[10, 50, 100]"
                     layout="prev, pager, next, sizes, total"
                     :total="pagination.total"></el-pagination>
    </div>
  </div>
</template>
<script>
import SelectAd from '@/components/common/selectAd'
import API from '@/api'
import { deleteConfirm, addConfirm, UserInput } from '@/utils'
import {mapGetters} from 'vuex'

export default {
    name: 'user',
    data() {
        return {
            data: [],
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            loading: false,
            searchContent: ''
        }
    },
    mounted() {
        this.getStaffList()
    },
    methods: {
        onAddAccount(list) {
            addConfirm().then(() => this.addUser(list))
        },
        onDeleteAccount(row) {
            deleteConfirm().then(() => this.deleteUser(row.id))
        },
        searchAdmin: _.debounce(
            function() {
                if (this.searchContent && !UserInput.reg1.test(this.searchContent)) {
                    this.$message.error(this.$t('ILLEGAL_USER_INPUT_02'))
                    return
                }
                this.onCurrentPageChange(1)
            },
            500,
            { leading: true }
        ),
        onSizeChange(size) {
          this.pagination.pageSize = size
          this.pagination.pageNum = 1
          this.getStaffList()
        },
        onCurrentPageChange(current) {
            this.pagination.pageNum = current
            this.getStaffList()
        },
        selectFromUser: params => API.system.querySysAdminUser(params),
        adFilter: v => Object.assign({}, v, { label: v.userName + '  (' + v.profitCenter + ')', value: v.id }),
        getStaffList: async function() {
            try {
                this.loading = true
                const { code, data, errDetails } = await API.system.queryAdminList({
                    ...this.pagination,
                    searchContent: this.searchContent
                })
                if (code == '1') {
                    this.data = data.records
                    this.pagination.total = data.total

                    this.loading = false
                } else {
                    this.$message.error(this.$t(code))
                }
            }
            catch(e) {}
            finally {
                this.loading = false
            }
        },
        deleteUser: async function(userId) {
            try {
                const { code, data, errDetails } = await API.system.deleteAdmin({
                    userId,
                    siteId: this.getSite.siteId
                })
                if (code == '1') {
                    this.getStaffList()
                } else {
                    this.$message.error(this.$t(code))
                }
            }
            catch(e) {}
            finally {}
        },
        addUser: async function(idList) {
            try {
                const { code, data, errDetails } = await API.system.addAdmin({
                    userId: idList[0].id
                })
                if (code == '1') {
                    this.$refs.selectAdd.clear()
                    this.getStaffList()
                } else {
                    this.$message.error(this.$t(code))
                }
            }
            catch(e) {}
            finally {}
        }
    },
    computed: {
      ...mapGetters('common', {
        getSite: 'getSite',
      })
    },
    components: {
        SelectAd
    }
}
</script>

<style scoped>
.wl-container {
    height: 100%;
    background: #eff1f5;
    padding: 22px;
}
.wl-content-container {
    background: #fff;
    height: 100%;
    padding: 22px 22px 16px 22px;
  border-radius: 8px;
}
.wl-search-bar {
    height: 45PX;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.wl-left,
.wl-right {
    display: flex;
    justify-content: flex-start;
    justify-items: center;
}
</style>
